import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// Assets
import logo from "../../assets/img/logoGrey.png";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            <Link className="flexCenter animate pointer" to="/">
              <img src={logo} alt="Maids Service Pakistan Logo" loading="lazy" style={{width:50}} />
              <h1 className="font15 extraBold whiteColor" style={{ marginLeft: "15px" }}>
                MaidsServicePakistan
              </h1>
            </Link>
            <StyleP className="whiteColor font13" style={{ textAlign: 'center' }}>
              © {getCurrentYear()} - 
              <span style={{ marginLeft: "5px" }}>
                Crafted with <a href="https://teccea.com" target="_blank" rel="noopener noreferrer" className="whiteColor extraBold" style={{ textDecoration: "underline" }}>Teccea</a> by Muhammad Ahtesham Ul Haq | 
                <a href="tel:+923459880990" className="whiteColor" style={{ marginLeft: "5px", textDecoration: "none" }}>+92-345-9880990</a>
              </span>
              <br />
              All Rights Reserved
            </StyleP>

            <Link className="whiteColor animate pointer font13" to="/">
              Back to Home
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;